import { Component, Inject, OnInit } from "@angular/core";
import { LayerListItem, TrvMap, TrvNgMapService } from "@trafikverket/trv-ng-map";
import { trvCollapseVoidAnimation, trvFadeAnimation } from "@trv-hub/trv-ng-common";
import { NvdbNavigationService } from "src/app/service/nvdb-navigation.service";
import { SvgIcon } from "src/app/shared/utils/svg-helper";
import { svgChevronDown, svgChevronUp, svgCross } from "src/app/shared/utils/svg-helper-data";
import LayerGroup from "ol/layer/Group";
import { environment } from "src/environments/environment";
import { SvgIconComponent } from "../../utils/svg-icon/svg-icon.component";
import { NgStyle } from "@angular/common";
import { Language, LanguageService } from "@app/service/language.service";

@Component({
    selector: "app-map-label",
    templateUrl: "./map-label.component.html",
    styleUrls: ["./map-label.component.scss"],
    animations: [trvFadeAnimation],
    imports: [
        NgStyle,
        SvgIconComponent
    ]
})
export class MapLabelComponent {
    public downIcon: SvgIcon = svgChevronDown;
    public upIcon: SvgIcon = svgChevronUp;

    constructor(
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        @Inject(NvdbNavigationService)
        public nvdbNavigation: NvdbNavigationService,
        public lang: LanguageService
    ) {}

    public getLegendGraphics(layer: LayerListItem) {
        if (layer.legendGraphics) {
            //return environment.baseApiUrl + "/MapProxy/mapProxyLegend/" + encodeURIComponent(layer.legendGraphics);
            return layer.legendGraphics;
        }
        return "";
    }

        public getDisplayName(layer: LayerListItem): string {
            const trvMap = this.trvMapService.trvMap!;
            const trvLayer = trvMap.trvLayer;
            if (this.lang.currentLanguage == Language.SV && trvLayer.hasLayerData(layer, "sweTitle")) {
                const displayName = trvLayer.getLayerData(layer, "sweTitle");
                return displayName;
            } else if (this.lang.currentLanguage == Language.ENG && trvLayer.hasLayerData(layer, "engTitle")) {
                const displayName = trvLayer.getLayerData(layer, "engTitle");
                return displayName;
            }
            return layer.name;
        }

}
